module.exports = __webpack_public_path__ + "assets/media/evening.52b4515b.mp3";